import { productImages } from './siteConfig';
import type { DetailRow, Faq, Feature, ProductImage, StoryStep } from '../types/content';

export const features: Feature[] = [
  {
    title: 'Laser facial technology',
    body: 'A laser mask for men and women, designed for use at home.',
  },
  {
    title: 'Handheld controller',
    body: 'A compact controller with a clear display and simple buttons.',
  },
  {
    title: '“Hi Mask” voice command',
    body: 'Say “Hi Mask” and control the mask hands-free.',
  },
];

export const galleryImages: ProductImage[] = [
  productImages.white,
  productImages.voice,
  productImages.kit,
];

export const storySteps: StoryStep[] = [
  {
    id: 'fit',
    title: 'Put it on',
    body: 'The soft, flexible mask rests over the face and is held in place by a head strap.',
    image: productImages.white,
  },
  {
    id: 'voice',
    title: 'Say “Hi Mask”',
    body: 'Wake the mask with a simple voice command and keep your hands free.',
    image: productImages.voice,
  },
  {
    id: 'controller',
    title: 'Or reach for the controller',
    body: 'Prefer buttons? The handheld controller pairs a small display with a simple layout.',
    image: productImages.controller,
  },
  {
    id: 'manual',
    title: 'Follow the manual',
    body: 'Settings and use guidance are set out in the user manual included in the box.',
    image: productImages.kit,
  },
];

export const kitContents: string[] = [
  'AuraGlow Luxe mask in White',
  'Handheld controller',
  'USB charging cable',
  'User manual',
];

export const productDetails: DetailRow[] = [
  { label: 'Color', value: 'White' },
  { label: 'Technology', value: 'Laser' },
  { label: 'Shell', value: 'Silicone' },
  { label: 'Eye area', value: 'Wide, open eye opening' },
  { label: 'Fit', value: 'Head strap' },
  { label: 'Controls', value: '“Hi Mask” voice command and handheld controller' },
  { label: 'Charging', value: 'USB charging cable included' },
  { label: 'Battery capacity', value: '1,800 mAh' },
  { label: 'Guidance', value: 'User manual included' },
];

export const faqs: Faq[] = [
  {
    id: 'technology',
    question: 'What type of light technology does the mask use?',
    answer: 'AuraGlow Luxe uses laser technology. The included manual explains the light settings and how to use the mask.',
  },
  {
    id: 'colors',
    question: 'Which colors are available?',
    answer: 'The AuraGlow Luxe mask launches in White.',
  },
  {
    id: 'voice',
    question: 'How does the voice command work?',
    answer: 'Say “Hi Mask” to get started. Refer to the included manual for setup and operating guidance.',
  },
  {
    id: 'controller',
    question: 'Can I use it without voice control?',
    answer: 'Yes. Every kit includes a handheld controller with a display and simple buttons.',
  },
  {
    id: 'sessions',
    question: 'How should I use it?',
    answer:
      'Please follow the user manual included in the box. If anything is unclear, our support team is happy to talk it through.',
  },
  {
    id: 'charging',
    question: 'How is it charged?',
    answer: 'With the USB charging cable included in the kit. Charging steps are covered in the manual.',
  },
  {
    id: 'who',
    question: 'Is it designed for men and women?',
    answer: 'AuraGlow Luxe is offered for men and women. Follow the product manual for suitability and use.',
  },
  {
    id: 'orders',
    question: 'Where can I find shipping and order details?',
    answer: 'Shipping is free. Orders usually ship in 1–2 days; this is the dispatch timeframe, not a delivery estimate. Tax is shown at checkout. For questions about your order, call our support team.',
  },
];

